import { styled } from '@mui/system';
import { Outlet } from 'react-router';

const StyledPaymentStatusWrapper = styled('div')(({theme}) => ({
  display: 'flex',
  flex: 1,
  gap: theme.spacing(8),
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  svg: {
    fill: '#1b1b1b'
  }
}));

export const PaymentStatusWrapper = () => {
  return (
    <StyledPaymentStatusWrapper>
      <Outlet />
    </StyledPaymentStatusWrapper>
  );
};
